// Copyright (c) Move Closer 2022.

import { Injectable, ResourceActionFailed } from '@movecloser/front-core'

import { CartIdentifier, IGraphQL } from '../../../contexts'
import { resolveFromStatus } from '../../../support'

import { IAnalyticsRepository } from '../contracts/repositories'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
@Injectable()
export class AnalyticsRepository implements IAnalyticsRepository {
  protected graphQlConnector: IGraphQL

  constructor (graphQlConnector: IGraphQL) {
    this.graphQlConnector = graphQlConnector
  }

  public async initCheckout (cartId: CartIdentifier): Promise<void> {
    const response = await this.graphQlConnector.call(
      'initCheckout',
      { cartId }
    )

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }
  }

  public async trackProductView (productId: number): Promise<void> {
    const response = await this.graphQlConnector.call(
      'trackPageContent',
      { productId }
    )

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }
  }

  public async trackPageView (url: string): Promise<void> {
    const response = await this.graphQlConnector.call(
      'trackPageView',
      { url }
    )

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }
  }
}
